import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=6606f876&scoped=true&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"
import style0 from "./FileRow.vue?vue&type=style&index=0&id=6606f876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606f876",
  null
  
)

export default component.exports